import React, { useRef } from 'react'

import './style.css'

const Toggle = ({
  toggled,
  onToggle,
  label = '',
  InputPosition = 'end',
  defaultChecked = false, // legacy (not used when controlled)
  defaultValue = false, // legacy
  isDisabled = false,
}) => {
  const inputIdRef = useRef(`toggle-${Math.random().toString(36).slice(2)}`)

  // Unified input props (controlled) fallback to defaultChecked if toggled is undefined
  const inputProps = {
    id: inputIdRef.current,
    type: 'checkbox',
    disabled: isDisabled,
    onChange: e => {
      // Rely only on onChange; parent controls state via 'toggled'
      onToggle && onToggle(e)
    },
  }
  if (typeof toggled === 'boolean') {
    inputProps.checked = toggled
  } else if (defaultChecked) {
    inputProps.defaultChecked = defaultChecked
  }
  if (defaultValue) inputProps.defaultValue = defaultValue

  const Switch = (
    <label
      className="switch"
      aria-disabled={isDisabled}
      htmlFor={inputIdRef.current}
    >
      <input {...inputProps} />
      <span className="slider round" />
    </label>
  )

  const TextLabel = label ? (
    <label className="toggle-label mr-2" htmlFor={inputIdRef.current}>
      {label}
    </label>
  ) : null

  return (
    <div
      className="custom-toggle"
      role="switch"
      aria-checked={!!toggled}
      aria-disabled={isDisabled}
    >
      {InputPosition === 'start' ? (
        <>
          {Switch}
          {TextLabel}
        </>
      ) : (
        <>
          {TextLabel}
          {Switch}
        </>
      )}
    </div>
  )
}

export default Toggle
